var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthleticAbilityIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27072 0.777328C9.66575 0.356275 10.3343 0.356275 10.7293 0.777328L19.6782 10.3158C20.2773 10.9544 19.8245 12 18.9489 12L1.05107 12C0.175456 12 -0.277319 10.9544 0.321787 10.3158L9.27072 0.777328Z",
    fill: "#4A90E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleticAbilityIcon5);
export default __webpack_public_path__ + "static/media/AthleticAbilityIcon_5.b3b4a00264de0f47ac1cb7ba5338a4c9.svg";
export { ForwardRef as ReactComponent };